import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(`grid grid-cols-12 gap-3 items-center border-b-2 border-b-gray-100 p-5 hover:bg-blue-50  overflow-hidden`)
}
const _hoisted_2 = { class: "col-span-12 md:col-span-10" }
const _hoisted_3 = { class: "flex items-center flex-wrap gap-5" }
const _hoisted_4 = { class: "flex justify-center" }
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = { class: "text-lg font-bold text-gray-800 mb-2" }
const _hoisted_7 = { class: "flex flex-wrap gap-3 md:divide-x divide-gray-500 text-gray-500 text-sm" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "ml-2 text-sm" }
const _hoisted_10 = { class: "col-span-12 md:col-span-2" }
const _hoisted_11 = {
  key: 0,
  class: "flex items-center justify-end gap-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_TagMaterials = _resolveComponent("TagMaterials")!
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_icon, {
            name: _ctx.materialsUtils.getIcon(_ctx.data.file?.mimetype),
            class: "text-h-primary-500",
            scale: 1.3
          }, null, 8, ["name", "scale"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.data.name), 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("objects.inputs.classification")) + ": " + _toDisplayString(_ctx.serviceChapter.getMaterialGroupName(_ctx.data.learningGroupType)), 1),
            _createVNode(_component_TagMaterials, { material: _ctx.data }, null, 8, ["material"]),
            (_ctx.statusObject(_ctx.data.file?.status) != 'DONE')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.statusObject(_ctx.data.file?.status)), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])), [
      [_directive_auto_animate, { duration: 1000 }]
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.role === 'TEACHER')
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_v_icon, {
              name: "md-edit",
              class: "text-h-primary-500 hover:scale-110 cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onEdit()))
            }),
            (_ctx.loading && _ctx.currentItem === _ctx.data)
              ? (_openBlock(), _createBlock(_component_v_icon, {
                  key: 0,
                  name: "ri-loader-5-fill",
                  class: "text-red-700 animate-spin"
                }))
              : (_openBlock(), _createBlock(_component_v_icon, {
                  key: 1,
                  name: "md-delete",
                  class: "text-red-700 hover:scale-110 cursor-pointer",
                  disabled: _ctx.loading,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onDelete(_ctx.data)))
                }, null, 8, ["disabled"]))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}